import { FormattedMessage } from 'react-intl';
import {
  DashboardOutlined,
  UserOutlined,
  MessageOutlined,
  DollarOutlined,
  CommentOutlined,
  BugOutlined,
  EyeOutlined,
  BulbOutlined,
  BarChartOutlined,
  MenuUnfoldOutlined,
  LogoutOutlined,
  WarningOutlined
} from '@ant-design/icons';

const icons = {
  DashboardOutlined,
  UserOutlined,
  MessageOutlined,
  DollarOutlined,
  CommentOutlined,
  BugOutlined,
  EyeOutlined,
  BulbOutlined,
  BarChartOutlined,
  MenuUnfoldOutlined,
  LogoutOutlined,
  WarningOutlined
};

const other = {
  id: 'other',
  title: <FormattedMessage id="others" />,
  type: 'group',
  children: [
    {
      id: 'home',
      title: <FormattedMessage id="menu.home" defaultMessage="🏠 Dashboard" />,
      type: 'item',
      url: '/home',
      icon: icons.DashboardOutlined
    },
    {
      id: 'users',
      title: <FormattedMessage id="menu.users" defaultMessage="👥 Users" />,
      type: 'item',
      url: '/users',
      icon: icons.UserOutlined
    },
    {
      id: 'messages-group',
      title: <FormattedMessage id="menu.messages" defaultMessage="💬 Messages" />,
      type: 'collapse',
      icon: icons.MessageOutlined,
      children: [
        {
          id: 'messages_all',
          title: <FormattedMessage id="menu.messages.all" defaultMessage="📋 All Messages" />,
          type: 'item',
          url: '/messages'
        },
        {
          id: 'messages_flagged',
          title: <FormattedMessage id="menu.messages.flagged" defaultMessage="🚩 Flagged" />,
          type: 'item',
          url: '/messages/flagged'
        }
      ]
    },
    {
      id: 'payments',
      title: <FormattedMessage id="menu.payments" defaultMessage="💳 Payments" />,
      type: 'item',
      url: '/payments',
      icon: icons.DollarOutlined
    },
    {
      id: 'feedback',
      title: <FormattedMessage id="menu.feedback" defaultMessage="💭 Feedback" />,
      type: 'item',
      url: '/feedback',
      icon: icons.CommentOutlined
    },
    {
      id: 'errors',
      title: <FormattedMessage id="menu.errors" defaultMessage="⚠️ Error Logs" />,
      type: 'item',
      url: '/errors',
      icon: icons.BugOutlined
    },
    {
      id: 'reveals',
      title: <FormattedMessage id="menu.reveals" defaultMessage="🔍 Reveals" />,
      type: 'item',
      url: '/reveals',
      icon: icons.EyeOutlined
    },
    {
      id: 'hints',
      title: <FormattedMessage id="menu.hints" defaultMessage="💡 Hints" />,
      type: 'item',
      url: '/hints',
      icon: icons.BulbOutlined
    },
    {
      id: 'analytics-group',
      title: <FormattedMessage id="menu.analytics" defaultMessage="📊 Analytics" />,
      type: 'collapse',
      icon: icons.BarChartOutlined,
      children: [
        {
          id: 'analytics_daily',
          title: <FormattedMessage id="menu.analytics.daily" defaultMessage="📅 Daily Stats" />,
          type: 'item',
          url: '/analytics/daily'
        },
        {
          id: 'analytics_retention',
          title: <FormattedMessage id="menu.analytics.retention" defaultMessage="🔄 Retention" />,
          type: 'item',
          url: '/analytics/retention'
        },
        {
          id: 'analytics_top_users',
          title: <FormattedMessage id="menu.analytics.top-users" defaultMessage="🏆 Top Users" />,
          type: 'item',
          url: '/analytics/top-users'
        },
        {
          id: 'analytics_revenue',
          title: <FormattedMessage id="menu.analytics.revenue" defaultMessage="💰 Revenue" />,
          type: 'item',
          url: '/analytics/revenue'
        },
        {
          id: 'analytics_hint_conversion',
          title: <FormattedMessage id="menu.analytics.hint-conversion" defaultMessage="🎯 Hint Conversion" />,
          type: 'item',
          url: '/analytics/hint-conversion'
        },
        {
          id: 'analytics_block_rate',
          title: <FormattedMessage id="menu.analytics.block-rate" defaultMessage="🚫 Block Rate" />,
          type: 'item',
          url: '/analytics/block-rate'
        }
      ]
    },
    {
      id: 'logout',
      title: (
        <span>
          <LogoutOutlined style={{ marginRight: 8 }} />
          Logout
        </span>
      ),
      type: 'item',
      url: '/logout'
    }
  ]
};

export default other;
